import { Icon } from "../Icon.js";
export class WrappedIcon extends Icon {
    async loadIcon(size, variant) {
        const icon = `${variant}-${size}`;
        let loadedIcon;
        switch (icon) {
            case "outlined-2xl":
                loadedIcon = (await import("./outlined-2xl.js")).default;
                break;
            case "outlined-lg":
                loadedIcon = (await import("./outlined-lg.js")).default;
                break;
            case "outlined-md":
                loadedIcon = (await import("./outlined-md.js")).default;
                break;
            case "outlined-xl":
                loadedIcon = (await import("./outlined-xl.js")).default;
                break;
            default: throw new Error("Invalid icon. Supported variants: outlined-2xl, outlined-lg, outlined-md, outlined-xl");
        }
        this._renderedIcon = loadedIcon;
    }
}
Icon.define("results", WrappedIcon);
